import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cta-box',
  templateUrl: './cta-box.component.html',
  styleUrls: ['./cta-box.component.scss']
})
export class CtaBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() { 
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-module/components/cta-box/cta-box.component.ts